import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import store from "./store";

export default new Vuex.Store(store);
